// extracted by mini-css-extract-plugin
module.exports = {"Interview":"styles_Interview__qaE3W","wrapper":"styles_wrapper__2V2BF","question":"styles_question__SCoYQ"};